<app-print-layout (cancelar)="cancelar()">
    <div class="card-body">
        <div>
            <div class="row mb-1">
                <div class="col-md-12" style="font-weight: bold; font-size: 18pt; text-align: center;">
                    FOLHA TESTE AMOSTRA - {{nomeAmostra}}
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12">
                    <div>Nº da Ordem de Serviço de Execução:</div>
                    <div>Unidade Auditada: {{Ug}}</div>
                    <div>Nº da Folha Teste:</div>
                    <div>Identificação da amostra: {{nomeAmostra}}</div>
                    <div>Identificação do nº do item da amostra:</div>
                    <div>Auditor Responsável:</div>
                    <div>Data de Preenchimento:</div>
                </div>
                <div class="col-md-12" style="padding-top: 15px;">
                    <table class="table" style="border: 1px solid #ccc; border-collapse: collapse; width: auto;">
                        <thead>
                            <tr>
                                <th colspan="2" style="width: 460px; text-align: center; border: 1px solid #ccc;">
                                    Procedimento / Teste
                                </th>
                                <th style="width: 300px; text-align: center; border: 1px solid #ccc;">
                                    Critério aplicável
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Avaliação
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Evidências
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Observações
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of model">
                                <td style="width: 60px; border: 1px solid #ccc; vertical-align: middle;">{{ item.codigo
                                    }}</td>
                                <td style="width: 400px; border: 1px solid #ccc; vertical-align: middle;">{{
                                    item.procedimento }}</td>
                                <td style="width: 300px; border: 1px solid #ccc;">{{ item.criterioAplicavel }}</td>
                                <td style="width: 130px; border: 1px solid #ccc;"></td>
                                <td style="width: 130px; border: 1px solid #ccc;"></td>
                                <td style="width: 130px; border: 1px solid #ccc;"></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</app-print-layout>